
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: "AIzaSyA-ueT9dc1krqjRKU9tF352br3PaoVqvdw",
  authDomain: "fcm-lms-uca.firebaseapp.com",
  projectId: "fcm-lms-uca",
  storageBucket: "fcm-lms-uca.firebasestorage.app",
  messagingSenderId: "1052571592643",
  appId: "1:1052571592643:web:221a00d99ce815e91cff76",
  measurementId: "G-X8QQHP2MP3"
}

const app = initializeApp(firebaseConfig)

export async function getMessagingInstance() {
  const supported = await isSupported()
  if (!supported) {
    return null
  }
  return getMessaging(app)
}

export { getToken, onMessage, isSupported }
